export const NoopPostprocessSearchResponseMiddleware = (response) => response;
export const NoopPostprocessFacetSearchResponseMiddleware = (response) => response;
export const NoopPostprocessQuerySuggestResponseMiddleware = (response) => response;
